/*
 * @Author: cc
 * @LastEditTime: 2021-05-13 10:22:17
 */
import PassWord from "./password";

export default PassWord;
